module.exports = __webpack_public_path__ + "img/cover3.07aaee26.png";